import { render, staticRenderFns } from "./RoomExamQuestionChoice.vue?vue&type=template&id=a5ddb8e4&"
import script from "./RoomExamQuestionChoice.vue?vue&type=script&lang=js&"
export * from "./RoomExamQuestionChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5ddb8e4')) {
      api.createRecord('a5ddb8e4', component.options)
    } else {
      api.reload('a5ddb8e4', component.options)
    }
    module.hot.accept("./RoomExamQuestionChoice.vue?vue&type=template&id=a5ddb8e4&", function () {
      api.rerender('a5ddb8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Exam/Question/RoomExamQuestionChoice.vue"
export default component.exports